module.exports = __webpack_public_path__ + "img/huaxia01.4c0dc3a2.png";